import { u as useDocumentEvent, D as DOCUMENT_EVENT_NAME_CLICK } from './hook-D51BbGUy.js';

const useDocumentClick = ({ onClickRef }) => {
    useDocumentEvent({
        eventName: DOCUMENT_EVENT_NAME_CLICK,
        eventHandlerRef: onClickRef,
    });
};

export { useDocumentClick as u };
//# sourceMappingURL=hook-CbBbLTHu.js.map
